import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3890381b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "go-back-text" }, "戻る", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-header" }, "アカウント詳細情報", -1))

import IconArrowLeft from "@/assets/svgs/icon_arrow_left.svg";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCardHeader',
  setup(__props) {

const router = useRouter();
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: goBack,
      class: "go-back-btn"
    }, [
      _createVNode(_unref(IconArrowLeft), { class: "go-back-icon" }),
      _hoisted_2
    ]),
    _hoisted_3
  ]))
}
}

})